'use client';

import { AuthAnimation } from './components/auth-animation';

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-background">
      {/* Left side — form */}
      <div className="flex w-full flex-col items-center justify-center px-6 py-12 lg:w-1/2">
        {children}
      </div>

      {/* Divider */}
      <div className="hidden lg:block">
        <div className="h-full w-px bg-gradient-to-b from-transparent via-border to-transparent" />
      </div>

      {/* Right side — animation */}
      <div className="hidden lg:flex lg:w-1/2 lg:items-center lg:justify-center">
        <div className="relative h-full w-full">
          <AuthAnimation />
        </div>
      </div>
    </div>
  );
}
